/* eslint-disable no-unused-vars */
/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable no-unused-expressions */
import { StandardTextFieldProps } from "@material-ui/core";
import { CountryCode } from "libphonenumber-js";
import React from "react";
import PhoneInput from "react-phone-input-2";
import "./material.css";
/**
 *
 * @param props
 * @version 0.3
 */

interface PhoneFieldProps extends StandardTextFieldProps {
  onValueChange?: (newValue: string) => void;
  countryCode?: CountryCode;
}

const PhoneField = ({ countryCode = "SN", value = "", ...props }: PhoneFieldProps) => {
  const { error, defaultValue, onValueChange, helperText, label, placeholder } = props;
  const [inputValue, setInputValue] = React.useState<string>(value as string);
  const ref = React.useRef(null);
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  React.useEffect(() => {
    if (defaultValue) {
      setInputValue((defaultValue as string) || "");
    }
  }, [defaultValue]);

  React.useEffect(() => {
    setInputValue((value as string) || "");
  }, [value]);

  const handleInputChange = (_value: string, _data: any, event: any) => {
    onValueChange && onValueChange(event?.target?.value || `+${_data?.dialCode || ""}`);
  };

  return (
    <PhoneInput
      ref={ref}
      {...props}
      value={inputValue}
      onChange={handleInputChange}
      country={countryCode.toLocaleLowerCase()}
      specialLabel={label as string}
      placeholder={placeholder}
      isValid={(_value, _country, _) => !error}
      defaultErrorMessage={`${helperText}`}
      autoFormat={false}
      enableAreaCodes
    />
  );
};

export default PhoneField;
